class SaveProfileEmailDto {
  email!: string;
}

export default SaveProfileEmailDto;
